import { render, staticRenderFns } from "./FormText.vue?vue&type=template&id=03281fba&scoped=true&"
import script from "./FormText.vue?vue&type=script&lang=tsx&"
export * from "./FormText.vue?vue&type=script&lang=tsx&"
import style0 from "./FormText.vue?vue&type=style&index=0&id=03281fba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03281fba",
  null
  
)

export default component.exports